import { Dimensions, Platform, StyleSheet } from 'react-native';
import colors, { appTheme } from '@/config/colors';
const width = Dimensions.get('window').width;

export const styles = StyleSheet.create({
  header: {
    flexDirection: 'column',
    zIndex: 1,
  },
  secondHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.grey,
    padding: 10,
    borderBottomColor: '#aaaa',
    borderBottomWidth: 1,
  },
  secondHeaderTitle: {
    fontSize: 18,
    color: colors.darkGrey,
    fontWeight: '700',
  },
  filter: {
    padding: 15,
    backgroundColor: colors.white,
  },
  filterStatic: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  filterRadioContainer: {
    flex: 0.8,
    flexDirection: 'row',
    alignItems: 'center',
  },
  filterRadioItem: {
    flex: 1,
  },
  filterRadioContainerTitle: {
    fontSize: 16,
    fontWeight: '700',
  },
  filterButtons: {
    flex: 0.2,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  filterButton: {
    width: 40,
    height: 40,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
  },
  checkboxesContainer: {
    flex: 0.75,
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 10,
  },
  checkboxTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: colors.darkGrey,
  },
  checkboxItem: {
    flex: 1,
  },
  phonemauswahlBtn: {
    padding: 10,
    marginVertical: 5,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
    width: 150,
  },
  hasLightGrayBg: {
    backgroundColor: colors.lightGrey,
  },
  hasLightGreenBg: {
    backgroundColor: appTheme.primary,
  },
  phonemauswahlContainer: {
    padding: 20,
  },
  phonemauswahlTitle: {
    fontSize: 18,
    textAlign: 'center',
    padding: 10,
    color: colors.darkGrey,
    fontWeight: '700',
  },
  sectorContainer: {
    padding: 10,
  },
  sectorContainerBody: {
    marginHorizontal: 10,
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  sectorContainerBodyItem: {
    width: Dimensions.get('window').width / 4,
    marginTop: 10,
  },
  modalContainer: {
    backgroundColor: colors.white,
    borderRadius: 2.5,
    width:
      Platform.OS === 'web'
        ? Dimensions.get('screen').width / 2.5
        : Dimensions.get('screen').width / 1.5,
  },
  modalHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#cccc',
  },
  modalBody: {
    padding: 10,
  },
  modalBodyInput: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBodyInputLabel: {
    marginHorizontal: 10,
    fontSize: 12,
    marginVertical: 5,
    color: '#bbbb',
  },
  modalFooter: {
    marginTop: 25,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalFooterBtn: {
    flex: 1,
    padding: 10,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalFooterBtnText: {
    fontSize: 16,
  },
  redBackgroundColor: {
    backgroundColor: 'red',
  },
  greenBackgroundColor: {
    backgroundColor: appTheme.primary,
  },
  greyBackgroundColor: {
    backgroundColor: '#cccc',
  },
  horizantalSeperator: {
    height: 1,
    backgroundColor: colors.darkGrey,
  },
  buttonShadowDrop: {
    shadowColor: '#171717',
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.4,
    shadowRadius: 6,
  },
  shadowDrop: {
    shadowColor: '#171717',
    shadowOffset: { width: 1, height: 1 },
    shadowOpacity: 0.5,
    shadowRadius: 5,
  },
  marginRight: {
    marginRight: 10,
  },
  dropDownContainer: {
    position: 'relative',
    zIndex: 1,
  },
  dropdown: {
    minWidth: width < 800 ? 250 : 420,
    height: 50,
    borderColor: 'gray',
    borderWidth: 0.5,
    borderRadius: 8,
    paddingHorizontal: 4,
  },
  icon: {
    marginRight: 5,
  },
  label: {
    position: 'absolute',
    backgroundColor: 'white',
    left: 22,
    top: 8,
    zIndex: 999,
    paddingHorizontal: 8,
    fontSize: 14,
  },
  placeholderStyle: {
    fontSize: 16,
    color: colors.newUI.therapist.grey70,
  },
  selectedTextStyle: {
    fontSize: 14,
    color: colors.newUI.therapist.textBlue100,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    color: colors.newUI.therapist.textBlue100,
  },
});
